import newsJson from '@/assets/news.json';
import indexProduct from '@/assets/index_product.json';
import product from '@/assets/product.json';

export function getImagePath(img_path, type) {
    if (img_path.includes("/assets/img/")){
        return 'https://nb-dx.oss-cn-hangzhou.aliyuncs.com'+ '/dist' + img_path
    }
    return 'https://nb-dx.oss-cn-hangzhou.aliyuncs.com' + '/dist/assets/img/' + type + "/" + img_path
}

export function getNewsData(reverse= true) {
    if (reverse){
        return newsJson.sort((a, b) => b.id - a.id);
    }
    return newsJson

}

export function getIndexProduct() {
    let productArray = []
    indexProduct.forEach((item)=>{
        product[item.key][item.index].img_url = getImagePath(product[item.key][item.index].path,"product")
        productArray.push(product[item.key][item.index])
    })
    return productArray

}